export default {
  // 页面标题
  title: "监控动态",

  // 筛选条件
  transactionDirection: "交易方向",
  inputCounterpartyAddress: "请输入交易对手地址",
  minAmount: "最小金额",
  maxAmount: "最大金额",
  maxAmountTip: "最大金额需≥最小金额",

  // 交易方向选项
  outflow: "流出",
  inflow: "流入",
  bidirectional: "双向",

  // 按钮
  reset: "重置",
  query: "查询",

  // 统计信息
  currentChain: "当前地址所属链：",
  totalCount: "共",
  totalDynamics: "条监控动态",
  unread: "条未读",
  markAllRead: "全部标为已读",

  // 表格列
  transactionTime: "交易时间",
  sender: "发送方",
  receiver: "接收方",
  currency: "币种",
  transactionQuantity: "交易数量",
  transactionHash: "交易哈希",
  operation: "操作",

  // 地址
  currentAddress: "当前地址",

  // 操作按钮
  markRead: "已读",
  addToMonitor: "加入监控",
  addToCanvas: "加入画布",

  // 对话框
  dialogAddMonitor: "添加监控",
  monitorAddSuccess: "地址监控添加成功",
  return: "返回",
  viewMonitor: "查看监控",

  // 提示信息
  loading: "拼命加载中",
  noData: "暂无数据",
  copySuccess: "复制成功",
};
